// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ApiKeyUpdate
 */
export interface ApiKeyUpdate {
  /**
   *
   */
  name?: string | null;
  /**
   *
   */
  revoked?: boolean | null;
}

/**
 * Check if a given object implements the ApiKeyUpdate interface.
 */
export function instanceOfApiKeyUpdate(value: object): value is ApiKeyUpdate {
  return true;
}

export function ApiKeyUpdateFromJSON(json: any): ApiKeyUpdate {
  return ApiKeyUpdateFromJSONTyped(json, false);
}

export function ApiKeyUpdateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiKeyUpdate {
  if (json == null) {
    return json;
  }
  return {
    name: json["name"] === undefined ? undefined : json["name"] === null ? null : json["name"],
    revoked:
      json["revoked"] === undefined ? undefined : json["revoked"] === null ? null : json["revoked"],
  };
}

export function ApiKeyUpdateToJSON(json: any): ApiKeyUpdate {
  return ApiKeyUpdateToJSONTyped(json, false);
}

export function ApiKeyUpdateToJSONTyped(
  value?: ApiKeyUpdate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    name: value["name"],
    revoked: value["revoked"],
  };
}
